export const KPI_TYPES = {
  TIMESHEETCOMPLIANCEINDEX: 'TIMESHEETCOMPLIANCEINDEX',
  BILLABILITYINDEX: 'BILLABILITYINDEX',
  SCHEDULEPERFORMANCEINDEX: 'SCHEDULEPERFORMANCEINDEX'
};
